// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2080":"f2c286da","4092":"f2c286da"}[chunkId] + ".chunk.css";
};